<template>
  <div class="idx-card">
    <div class="col">
      <div class="row">
        <div class="card-icon">
          <font-awesome-icon
            :icon="['fas', icon]"
            class="ml-2"
            style="font-size: 20px"
          />
        </div>
        <div class="cart-title">
          <h4>{{ title }}</h4>
          <small v-if="subtitle">{{ subtitle }}</small>
        </div>
      </div>
      <div class="row">
        <div v-if="volume > 0" class="card-value">
          {{ volume }}
        </div>
        <div class="chart-card" v-else>
           -
        </div>
        <div v-if="percentil > 0" class="chart-card">
          <!-- <b-spinner
            variant="primary"
            type="grow"
            label="Spinning"
            style="width: 3rem; height: 3rem;"
          ></b-spinner> -->
          <template>
            <radial-progress-bar
              startColor="#4ce595"
              stopColor="#4ce595"
              :diameter="80"
              :stroke-width="5"
              innerStrokeColor="#f1f1f1"
              :completed-steps="percentil ? percentil : 0"
              :total-steps="100"
            >
              <animated-number
                :value="percentil ? percentil : 0"
                :formatValue="formatToPrice"
                :duration="1000"
              />
            </radial-progress-bar>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress';
import animatedNumber from 'animated-number-vue';

export default {
  name: 'Card',
  components: {
    RadialProgressBar,
    animatedNumber,
  },
  props: ['title', 'subtitle', 'icon', 'percentil', 'volume'],
  methods: {
    formatToPrice(value) {
      return `${value.toFixed(0)}%`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.idx-card {
  margin-top: 16px;
  background-color: $white;
  border-radius: 4px;
  border: 1px solid $gray-light;
  width: 100%;
  height: 169px;
  padding: 8px;
  color: $title-color;

  > div {
    height: 100%;
  }
  .card-icon {
    width: 70px;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .cart-title {
    width: calc(100% - 70px);
    height: 70px;
    display: flex;
    flex-direction: column;
    padding: 8px;
    align-items: left;
    justify-content: center;
    h4 {
      margin: 0;
      padding: 0;
      font-weight: 400;
    }
    small {
      margin: 0;
      padding: 0;
      font-weight: 100;
    }
  }
  .card-value {
    width: 120px;
    padding: 8px;
    font-size: 1.5em;
    height: calc(169px - 89px);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 100;
  }
  .chart-card {
    width: calc(100% - 120px);
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    height: calc(169px - 89px);
    padding: 16px;
  }
}
</style>
<style lang="scss">
.radial-progress-inner {
  justify-content: center;
  font-size: 1.3em;
  cursor: pointer;
  font-weight: 100;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/card-items/index.vue